(function () {
  // 2. Define HTML content generator
  function generateStepperHTML(totalSteps) {
    let html = `<div id="bundle-app-new-stepper-root" class="bundle-app-new-stepper-container" data-total-steps="${totalSteps}">`;

    // Spacer at Start
    html += `<div class="bundle-app-new-spacer"></div>`;

    for (let i = 1; i <= totalSteps; i++) {
      html += `
            <!-- Step ${i} -->
            <div class="bundle-app-new-step" id="bundle-app-new-step-${i}">
                <div class="bundle-app-new-step-box">${i}</div>
                <div class="bundle-app-new-step-label">Select your</div>
                <div class="bundle-app-new-step-sublabel">Item ${i}</div>
            </div>
            `;

      if (i < totalSteps) {
        html += `<div class="bundle-app-new-connector"></div>`;
      }
    }

    // Spacer at End
    html += `<div class="bundle-app-new-spacer"></div>`;

    // Arrow pointing to Add To Cart
    html += `
            <div class="bundle-app-new-arrow-icon">
                <svg width="30" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        </div>
        `;
    return html;
  }

  // 3. Logic to Sync UI with App State
  function syncStepperState() {
    // Prevent concurrent execution
    if (window.bundleAppSyncing) return;
    window.bundleAppSyncing = true;

    try {
      const footer = document.querySelector(
        ".gbbPageFooterHTML, .gbbAddProductsPageFooterHTML",
      );
      if (!footer) {
        return;
      }

      // Determine total steps dynamically
      let totalSteps = 4; // Fallback
      if (
        window.tmpCartSettings2 &&
        window.tmpCartSettings2.stepsConfigurationData &&
        window.tmpCartSettings2.stepsConfigurationData.productsData1 &&
        window.tmpCartSettings2.stepsConfigurationData.productsData1
          .conditions &&
        window.tmpCartSettings2.stepsConfigurationData.productsData1.conditions
          .length > 0
      ) {
        const condition =
          window.tmpCartSettings2.stepsConfigurationData.productsData1
            .conditions[0];
        if (condition && condition.type === "quantity") {
          totalSteps = parseInt(condition.value, 10) || 4;
        }
      }

      // Check if we need to regenerate HTML (if bundle size changed or not yet rendered)
      const existingRoot = document.getElementById(
        "bundle-app-new-stepper-root",
      );
      if (existingRoot) {
        const renderedSteps = parseInt(
          existingRoot.getAttribute("data-total-steps") || "0",
          10,
        );
        if (renderedSteps !== totalSteps) {
          // Re-render if size mismatch
          existingRoot.remove();
          injectStepper(footer, totalSteps);
          return; // Exit, mutation observer will likely trigger again or we wait for next cycle
        }
      } else {
        injectStepper(footer, totalSteps);
        // Continue to sync this pass
      }

      // Find all added product containers
      const products = footer.querySelectorAll(".gbbFooterProductContainer");

      // Flatten products based on quantity
      // { productIndex: number, img: string }
      let filledSlots = [];

      products.forEach((product, index) => {
        // Parse quantity
        let qty = 1;
        const qtyEl = product.querySelector(".gbbFooterProductQuantity");
        if (qtyEl) {
          const qtyText = qtyEl.innerText.trim().toLowerCase(); // e.g. "x2"
          const match = qtyText.match(/x?(\d+)/);
          if (match && match[1]) {
            qty = parseInt(match[1], 10);
          }
        }

        const imgEl = product.querySelector(".gbbFooterProductImage");
        const imgSrc = imgEl ? imgEl.src : "";

        for (let k = 0; k < qty; k++) {
          filledSlots.push({
            productIndex: index, // keep track of which product in the footer list this corresponds to
            img: imgSrc,
          });
        }
      });

      // Now map filledSlots to steps
      for (let i = 0; i < totalSteps; i++) {
        const stepNode = document.getElementById(
          `bundle-app-new-step-${i + 1}`,
        );
        if (!stepNode) continue;

        const stepBox = stepNode.querySelector(".bundle-app-new-step-box");
        const slotData = filledSlots[i];

        if (slotData) {
          // --- STATE: FILLED ---
          if (!stepNode.classList.contains("filled")) {
            stepNode.classList.remove("active");
            stepNode.classList.add("filled");

            stepBox.innerHTML = `
                            <img src="${slotData.img}" class="bundle-app-new-step-img" alt="Selected Product">
                            <div class="bundle-app-new-step-close" data-product-index="${slotData.productIndex}">✕</div>
                        `;
          } else {
            // Update image if needed
            const currentImg = stepBox.querySelector("img");
            if (currentImg && currentImg.src !== slotData.img) {
              currentImg.src = slotData.img;
            }
            // Update close button index if shifted
            const closeBtn = stepBox.querySelector(
              ".bundle-app-new-step-close",
            );
            if (closeBtn) {
              closeBtn.setAttribute(
                "data-product-index",
                slotData.productIndex,
              );
            }
          }
        } else {
          // --- STATE: EMPTY ---
          if (stepNode.classList.contains("filled")) {
            stepNode.classList.remove("filled");
            stepBox.innerHTML = `${i + 1}`;
          }

          // Active logic: The first empty step is active
          if (i === filledSlots.length) {
            stepNode.classList.add("active");
          } else {
            stepNode.classList.remove("active");
          }
        }
      }

      // --- BUTTON STATE: Disable if not complete ---
      const nextBtn = document.querySelector(".gbbFooterNextButton");
      if (nextBtn) {
        // Clear any "Next" text and ensure only "ADD TO CART" shows
        if (
          nextBtn.textContent &&
          nextBtn.textContent.trim().toLowerCase().includes("next")
        ) {
          nextBtn.textContent = "";
        }

        const isComplete = filledSlots.length === totalSteps;
        if (isComplete) {
          nextBtn.classList.remove("bundle-app-disabled-btn");
          nextBtn.disabled = false;
        } else {
          nextBtn.classList.add("bundle-app-disabled-btn");
          nextBtn.disabled = true;
        }
      }

      // --- SHOWCASE PRICE AND DISCOUNT PRICE ---
      showcasePrices(footer);
    } finally {
      // Reset flag
      window.bundleAppSyncing = false;
    }
  }

  // Function to clear button text and ensure only "ADD TO CART" shows
  function clearButtonText() {
    const nextBtn = document.querySelector(".gbbFooterNextButton");
    if (nextBtn) {
      // Clear any text content that might say "Next" or any other text
      const text = nextBtn.textContent || nextBtn.innerText || "";
      if (
        text.trim().length > 0 &&
        !text.trim().toUpperCase().includes("ADD TO CART")
      ) {
        nextBtn.textContent = "";
        nextBtn.innerText = "";
      }
      // Also clear any child text nodes
      const childNodes = Array.from(nextBtn.childNodes);
      childNodes.forEach((node) => {
        if (node.nodeType === 3 && node.textContent.trim().length > 0) {
          node.textContent = "";
        }
      });
    }
  }

  function injectDiscountTags() {
    const containers = document.querySelectorAll(
      ".gbbProductItemPricesContainer, .gbbProductVariantModalMainContainer",
    );
    containers.forEach((container) => {
      if (container.querySelector(".gbbProductDiscountTag")) return;

      const priceEl = container.querySelector(".gbbProductItemPrice");
      const compareEl = container.querySelector(
        ".gbbProductItemCompareAtPrice",
      );

      if (priceEl && compareEl) {
        if (priceEl.textContent.includes(".00")) {
          priceEl.textContent = priceEl.textContent.replace(".00", "");
        }
        if (compareEl.textContent.includes(".00")) {
          compareEl.textContent = compareEl.textContent.replace(".00", "");
        }
        const priceText = priceEl.textContent.replace(/[^\d.]/g, "");
        const compareText = compareEl.textContent.replace(/[^\d.]/g, "");

        const price = parseFloat(priceText);
        const compare = parseFloat(compareText);

        if (!isNaN(price) && !isNaN(compare) && compare > price) {
          const discount = Math.round(((compare - price) / compare) * 100);
          if (discount > 0) {
            const tag = document.createElement("span");
            tag.className = "gbbProductDiscountTag";
            tag.textContent = `(${discount}% OFF)`;

            // Append next to compare price
            if (compareEl.nextSibling) {
              compareEl.parentNode.insertBefore(tag, compareEl.nextSibling);
            } else {
              compareEl.parentNode.appendChild(tag);
            }
          }
        }
      }
    });
  }

  function convertSelectToTabs() {
    const wrapper = document.querySelector(".gbbAddGiftBoxPageWrapper, .gbbProductsItemsContainer");
    if (!wrapper) return;

    const selects = wrapper.querySelectorAll("select");
    
    selects.forEach(select => {
      if (select.dataset.tabsInitialized) return;
      
      select.style.display = "none";
      select.dataset.tabsInitialized = "true";

      const tabsContainer = document.createElement("div");
      tabsContainer.className = "bundle-custom-tabs-container";

      Array.from(select.options).forEach(option => {
        if (!option.text || option.text.trim() === '') return;

        const tab = document.createElement("button");
        tab.className = "bundle-custom-tab";
        if (option.selected) {
          tab.classList.add("active");
        }
        // Strip unicode arrows and trim
        let cleanText = option.text.replace(/[\u25BC\u25B2\u2304\u2303▼▲⌄⌃˅^]/g, '').trim();
        tab.textContent = cleanText;

        // Hide any SVG icons (like chevrons) in the select's wrapper
        Array.from(select.parentNode.querySelectorAll('svg')).forEach(svg => svg.style.display = 'none');
        
        tab.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          tabsContainer.querySelectorAll(".bundle-custom-tab").forEach(t => t.classList.remove("active"));
          tab.classList.add("active");

          select.value = option.value;
          const event = new Event('change', { bubbles: true });
          select.dispatchEvent(event);
        });

        tabsContainer.appendChild(tab);
      });

      select.parentNode.insertBefore(tabsContainer, select);
    });
  }

  function injectSizeChart() {
    const modal = document.querySelector(".gbbProductVariantModalMainContainer");
    if (!modal || modal.querySelector(".bundle-size-chart-link")) return;

    const titleEl = modal.querySelector(".gbbProductItemTitle");
    if (!titleEl) return;

    const titleText = titleEl.textContent.toLowerCase();
    let chartUrl = "";

    if (window.bundlePageSizeCharts) {
        let activeCategory = "";
        const allTabs = document.querySelectorAll('button, a, span, div, .eb-category-item');
        let foundAnyTab = false;

        for (let el of allTabs) {
            const txt = el.textContent.toLowerCase().trim();
            const isGenderTab = txt === "men" || txt === "women";
            if (isGenderTab) foundAnyTab = true;

            if (isGenderTab && (
                el.classList.contains('active') || 
                el.classList.contains('selected') || 
                el.parentElement.classList.contains('active') || 
                el.parentElement.classList.contains('selected') ||
                el.getAttribute('aria-selected') === 'true'
            )) {
                activeCategory = txt;
                break;
            }
        }

        if (!foundAnyTab) {
            // Rule 1: If there is no tab it should show men one
            chartUrl = window.bundlePageSizeCharts.men || "";
        } else {
            // Rule 2 & 3: Filter strictly by category
            if (activeCategory === "women" || titleText.includes("women")) {
                chartUrl = window.bundlePageSizeCharts.women || "";
            } else if (activeCategory === "men" || titleText.includes("men")) {
                chartUrl = window.bundlePageSizeCharts.men || "";
            } else {
                chartUrl = "";
            }
        }
    }

    if (!chartUrl || chartUrl === "" || chartUrl.includes("no-image") || chartUrl.includes("undefined")) return;

    const link = document.createElement("a");
    link.className = "bundle-size-chart-link";
    link.textContent = "Size Chart";
    link.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        showSizeChartModal(chartUrl);
    });

    const sizeOptionLabel = modal.querySelector('.gbbProductVariantOptionContainer[optionid="Size"] .gbbProductVariantOptionLabelContainer');
    if (sizeOptionLabel) {
        sizeOptionLabel.style.display = "flex";
        sizeOptionLabel.style.justifyContent = "space-between";
        sizeOptionLabel.style.alignItems = "center";
        sizeOptionLabel.appendChild(link);
    } else {
        const pricesContainer = modal.querySelector(".gbbProductItemPricesContainer");
        if (pricesContainer) {
            pricesContainer.parentNode.insertBefore(link, pricesContainer.nextSibling);
        } else {
            titleEl.parentNode.insertBefore(link, titleEl.nextSibling);
        }
    }
  }

  function showSizeChartModal(url) {
    let modal = document.getElementById("bundle-size-chart-popup");
    if (!modal) {
        modal = document.createElement("div");
        modal.id = "bundle-size-chart-popup";
        modal.className = "bundle-size-chart-modal";
        modal.innerHTML = `
            <div class="bundle-size-chart-content">
                <span class="bundle-size-chart-close">&times;</span>
                <img class="bundle-size-chart-img" src="" alt="Size Chart">
            </div>
        `;
        document.body.appendChild(modal);
        modal.querySelector(".bundle-size-chart-close").addEventListener("click", () => {
            modal.style.display = "none";
        });
        modal.addEventListener("click", (e) => {
            if (e.target === modal) modal.style.display = "none";
        });
    }
    modal.querySelector(".bundle-size-chart-img").src = url;
    modal.style.display = "flex";
  }

  // Function to showcase price and discount price
  function showcasePrices(footer) {
    if (!footer) return;

    // Prevent infinite loops - check if we're already processing
    if (window.bundleAppShowcasingPrices) return;
    window.bundleAppShowcasingPrices = true;

    try {
      // Clear button text
      clearButtonText();
      // Find the total container
      const totalContainer = footer.querySelector(".gbbFooterTotalContainer");
      if (!totalContainer) {
        window.bundleAppShowcasingPrices = false;
        return;
      }

      // Hide the TOTAL label
      const totalLabel = totalContainer.querySelector(".gbbFooterTotalLabel");
      if (totalLabel) {
        totalLabel.style.display = "none";
      }

      // Ensure it's visible
      totalContainer.style.display = "flex";
      totalContainer.style.visibility = "visible";

      // Find price elements
      const originalPriceEl = totalContainer.querySelector(
        ".gbbFooterOriginalTotalValue",
      );
      const discountedPriceEl = totalContainer.querySelector(
        ".gbbFooterDiscountedTotalValue",
      );
      const totalValueContainer = totalContainer.querySelector(
        ".gbbFooterTotalValueContainer",
      );

      // If price elements exist, ensure they're visible and properly styled
      if (originalPriceEl) {
        if (originalPriceEl.textContent.includes(".00")) {
          originalPriceEl.textContent = originalPriceEl.textContent.replace(
            ".00",
            "",
          );
        }
        originalPriceEl.style.display = "block";
        originalPriceEl.style.visibility = "visible";
      }

      if (discountedPriceEl) {
        if (discountedPriceEl.textContent.includes(".00")) {
          discountedPriceEl.textContent = discountedPriceEl.textContent.replace(
            ".00",
            "",
          );
        }
        discountedPriceEl.style.display = "block";
        discountedPriceEl.style.visibility = "visible";
      }

      if (totalValueContainer) {
        totalValueContainer.style.display = "flex";
        totalValueContainer.style.flexDirection = "row";
        totalValueContainer.style.alignItems = "center";
        totalValueContainer.style.justifyContent = "center";
        totalValueContainer.style.gap = "12px";
        totalValueContainer.style.visibility = "visible";
      }

      // Position price container above the button - only move if not already in correct position
      const buttonsContainer = footer.querySelector(
        ".gbbFooterButtonsContainer, .gbbFooterButtonsWrapper",
      );
      if (buttonsContainer) {
        const buttonsWrapper =
          buttonsContainer.querySelector(".gbbFooterButtonsWrapper") ||
          buttonsContainer;

        // Check if already in correct position
        const isAlreadyPositioned =
          totalContainer.parentElement === buttonsWrapper &&
          buttonsWrapper.contains(totalContainer) &&
          (totalContainer.nextElementSibling ===
            buttonsWrapper.querySelector(".gbbFooterNextButton") ||
            totalContainer.previousElementSibling ===
              buttonsWrapper.querySelector(".gbbFooterNextButton"));

        if (!isAlreadyPositioned) {
          // Temporarily disconnect observer to prevent loop
          const nextButton = buttonsWrapper.querySelector(
            ".gbbFooterNextButton",
          );
          if (nextButton && totalContainer.parentElement !== buttonsWrapper) {
            buttonsWrapper.insertBefore(totalContainer, nextButton);
          } else if (
            !nextButton &&
            totalContainer.parentElement !== buttonsWrapper
          ) {
            buttonsWrapper.insertBefore(
              totalContainer,
              buttonsWrapper.firstChild,
            );
          }
        }
      }
    } finally {
      // Reset flag after a short delay to allow DOM to settle
      setTimeout(() => {
        window.bundleAppShowcasingPrices = false;
      }, 100);
    }
  }

  // 4. Handle Clicks (Delegation)
  function handleStepperClick(e) {
    if (e.target.classList.contains("bundle-app-new-step-close")) {
      const index = parseInt(e.target.getAttribute("data-product-index"), 10);
      console.log(`bundle-app-new: Close clicked for product index ${index}.`);

      const footer = document.querySelector(
        ".gbbPageFooterHTML, .gbbAddProductsPageFooterHTML",
      );
      if (footer) {
        const products = footer.querySelectorAll(".gbbFooterProductContainer");
        const productToRemove = products[index];

        if (productToRemove) {
          const removeBtn = productToRemove.querySelector(
            ".gbbFooterProductRemoveButton",
          );
          if (removeBtn) {
            removeBtn.click();
            console.log(
              "bundle-app-new: Triggered remove button for index",
              index,
            );
          } else {
            console.warn(
              "bundle-app-new: Remove button not found for product at index",
              index,
            );
          }
        } else {
          console.warn(
            "bundle-app-new: Product container not found at index",
            index,
          );
        }
      }
    }
  }

  // 5. Initialization
  function initStepper() {
    console.log("bundle-app-new: initializing...");

    // Throttle function to prevent excessive calls
    let syncTimeout = null;
    function throttledSync() {
      if (syncTimeout) return;
      syncTimeout = setTimeout(() => {
        syncTimeout = null;
        clearButtonText();
        injectDiscountTags();
        convertSelectToTabs();
        const footer = document.querySelector(
          ".gbbPageFooterHTML, .gbbAddProductsPageFooterHTML",
        );
        if (footer && !window.bundleAppShowcasingPrices) {
          syncStepperState();
        }
      }, 150);
    }

    // Observe Footer Changes with throttling
    const observer = new MutationObserver((mutations) => {
      // Run instantly to prevent native select from flashing before 150ms throttle
      convertSelectToTabs();
      injectSizeChart();

      // Skip if we're currently showcasing prices to prevent loops
      if (window.bundleAppShowcasingPrices) return;

      const footer = document.querySelector(
        ".gbbPageFooterHTML, .gbbAddProductsPageFooterHTML",
      );

      if (footer) {
        // Use throttled sync
        throttledSync();

        // Clean up generic text nodes (from previous logic)
        const possibleText = footer.childNodes[0];
        if (
          possibleText &&
          possibleText.nodeType === 3 &&
          possibleText.textContent.trim().length > 0
        ) {
          possibleText.textContent = "";
        }

        // ANTIGRAVITY: Move footer to top to act as header
        const wrapper = document.querySelector(".gbbAddGiftBoxPageWrapper");
        if (wrapper && footer && wrapper.firstChild !== footer) {
          wrapper.insertBefore(footer, wrapper.firstChild);
          console.log("bundle-app-new: Moved footer to top of wrapper");

          // Initialize sticky logic immediately after move
          initStickyHeader();
        } else if (wrapper && footer && wrapper.firstChild === footer) {
          // If already moved, ensuring sticky logic is active
          initStickyHeader();
        }
      }
    });

    // Observe only specific parts to reduce triggers
    const targetNode = document.body;
    observer.observe(targetNode, {
      childList: true,
      subtree: true,
      attributes: false, // Don't watch attribute changes
      characterData: false, // Don't watch text changes
    });

    // Initial run
    setTimeout(() => {
      clearButtonText();
      syncStepperState();
      initStickyHeader();
      injectSizeChart();
    }, 100);

    // Attach Click Listener (Global delegation)
    document.addEventListener("click", handleStepperClick);
  }

  function injectStepper(footer, totalSteps) {
    if (!document.getElementById("bundle-app-new-stepper-root")) {
      const buttonsWrapper = footer.querySelector(
        ".gbbFooterButtonsWrapper, .gbbFooterButtonsContainer",
      );

      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = generateStepperHTML(totalSteps);
      const stepperNode = tempDiv.firstElementChild;

      if (buttonsWrapper && buttonsWrapper.parentElement) {
        buttonsWrapper.parentElement.insertBefore(stepperNode, buttonsWrapper);
      } else {
        footer.appendChild(stepperNode);
      }
    }
  }

  // 6. Sticky to Bottom Logic
  function initStickyHeader() {
    const footer = document.querySelector(".gbbAddProductsPageFooterHTML");

    if (!footer) {
      return;
    }

    // Make footer sticky to bottom by default - full width
    footer.style.position = "fixed";
    footer.style.bottom = "0";
    footer.style.left = "0";
    footer.style.right = "0";
    footer.style.width = "100%";
    footer.style.zIndex = "10000";
    footer.style.background = "white";
    footer.style.boxShadow = "0 -2px 10px rgba(0, 0, 0, 0.1)";
    footer.style.padding = "15px 20px";
    footer.style.boxSizing = "border-box";

    // Ensure inner div respects max-width
    const innerDiv = Array.from(footer.children).find(
      (child) => child.tagName === "DIV",
    );
    if (innerDiv) {
      const containerWidth =
        getComputedStyle(document.documentElement).getPropertyValue(
          "--container-width",
        ) || "1280px";
      innerDiv.style.maxWidth = containerWidth;
      innerDiv.style.margin = "0 auto";
      innerDiv.style.width = "100%";
    }

    // Add padding to body to prevent content from being hidden
    function updateBodyPadding() {
      const footerHeight = footer.offsetHeight;
      document.body.style.paddingBottom = footerHeight + "px";
    }

    // Update on resize
    if (!window.gbbStickyListenerAttached) {
      window.addEventListener("resize", updateBodyPadding, { passive: true });
      window.gbbStickyListenerAttached = true;
    }

    // Initial padding update
    updateBodyPadding();

    // Update padding after a short delay to ensure footer is rendered
    setTimeout(updateBodyPadding, 100);
    setTimeout(updateBodyPadding, 500);

    console.log("bundle-app-new: Sticky to bottom initialized - full width");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      initStepper();
    });
  } else {
    initStepper();
  }
})();
